import axios from "axios"
import ENV from "../../../../../envProperties"
import { sendGtmEventError } from "services/utils/sendGtm"

const HTTP_REQUEST_HEADER = {
  "Content-Type": "application/json",
  "x-app-origin": "portal-b2b"
}

export const BASE_URL = `${ENV.BFF}`

const instance = axios.create({
  baseURL: BASE_URL,
  headers: HTTP_REQUEST_HEADER
})

const interceptors = { request: [], response: [] }

interceptors.request.push({
  success: (unused, request) => {
    request.headers.Authorization = window.localStorage.getItem("tokenPortal")

    return request
  },

  error: (unused, error) => Promise.reject(error)
})

interceptors.response.push({
  error: ({ dispatch }, error) => {
    let token = window.localStorage.getItem("tokenPortal")

    if (error.response && error.response.status !== 401 && token) {
      sendGtmEventError(error.response.status, error.response.data)

      return Promise.reject(error)
    }

    return instance.post("/ip-token").then((res) => {
      token = `Bearer ${res.data.access_token}`
      window.localStorage.setItem("tokenPortal", token)
      return instance(error.config)
    })
  }
})

export default { client: instance, options: { interceptors } }



// WEBPACK FOOTER //
// ./src/services/state/middlewares/axios/clients/bff-pub.js